import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { ProposalsTab } from "@/components/admin/ProposalsTab";
import { DossiersTab } from "@/components/admin/DossiersTab";
import { SourcesTab } from "@/components/admin/SourcesTab";
import { CommentsTab } from "@/components/admin/CommentsTab";
import { PointsAuditTab } from "@/components/admin/PointsAuditTab";

const STAT_LABELS = [
  ["proposte_in_attesa", "Proposte in attesa"], ["commenti_segnalati", "Commenti segnalati"],
  ["dossier_pubblicati", "Dossier pubblicati"], ["dossier_bozza", "Dossier in bozza"],
  ["fonti_candidate", "Fonti da verificare"], ["utenti", "Utenti registrati"],
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const loadStats = () => api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  useEffect(() => { loadStats(); }, []);
  return (
    <div className="space-y-8">
      <div>
        <p className="flex items-center gap-2 text-sm font-bold text-violet-300"><ShieldCheck size={16} /> Area riservata</p>
        <h1 className="text-4xl font-bold">Lumacofono · Fondatore</h1>
        <p className="mt-1 text-sm text-muted-foreground">Nessuna email automatica: le nuove proposte compaiono qui. Ogni azione è registrata nell'audit.</p>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-6">
        {STAT_LABELS.map(([k, l]) => (
          <div key={k} className="luma-card p-4" data-testid={`admin-stat-${k}`}>
            <p className="font-display text-2xl font-bold">{stats?.[k] ?? "–"}</p><p className="text-xs text-muted-foreground">{l}</p>
          </div>
        ))}
      </div>
      <Tabs defaultValue="proposte">
        <TabsList className="flex h-auto flex-wrap rounded-2xl">
          <TabsTrigger value="proposte" data-testid="admin-tab-proposals">Proposte</TabsTrigger>
          <TabsTrigger value="dossier" data-testid="admin-tab-dossiers">Dossier</TabsTrigger>
          <TabsTrigger value="fonti" data-testid="admin-tab-sources">Fonti</TabsTrigger>
          <TabsTrigger value="commenti" data-testid="admin-tab-comments">Commenti</TabsTrigger>
          <TabsTrigger value="punti" data-testid="admin-tab-audit">Punti & audit</TabsTrigger>
        </TabsList>
        <TabsContent value="proposte" className="pt-4"><ProposalsTab onChange={loadStats} /></TabsContent>
        <TabsContent value="dossier" className="pt-4"><DossiersTab /></TabsContent>
        <TabsContent value="fonti" className="pt-4"><SourcesTab onChange={loadStats} /></TabsContent>
        <TabsContent value="commenti" className="pt-4"><CommentsTab onChange={loadStats} /></TabsContent>
        <TabsContent value="punti" className="pt-4"><PointsAuditTab /></TabsContent>
      </Tabs>
    </div>
  );
}
